<!--
	PublicSearchBar.svelte

    10/13 - This has been greatly simplified to only call the parent search functions.
    The user can choose to run a new POSTAL search or a FILTER search.
    The POSTAL search is what renders the TaxonomyMenu on the page.

    Contains:
    
        <Textfield>                 // ZIP Code
            <SearchIcon>            // magnifying glass
        <Textfield>                 // free text
            <SearchIcon>            // magnifying glass

    All surrounded by an oval outline.
-->

<script>

    import { onMount } from 'svelte';
	import { clearAlert } from '../../stores/AlertsStore';
    import { masterSearch } from "../../common/master-objects";
    import { isRunningSearch, taxonomyMenuBreadcrumb, getBreadcrumbLength } from '../../stores/ScreenSettingsStore';
    
    // SMUI components
    import { Icon } from '@smui/icon-button';
	import { Svg } from '@smui/common/elements';
	import { mdiMagnify } from '@mdi/js';

    // Icons
    import MdErrorOutline from 'svelte-icons/md/MdErrorOutline.svelte'
    import MdSearch from 'svelte-icons/md/MdSearch.svelte'
    import {asyncValidatePostalCode} from "../../common/utils";

    export let store;                                               // Search object - $masterSearch
    export let onPostalSearch;                                      // on PublicResourcesPage
    export let onFilterSearch;                                      // on PublicResourcesPage
    export let isShowingFreeText;
    export let isShowingZipError;
    
    // $: breadcrumbLength = $taxonomyMenuBreadcrumb ? getBreadcrumbLength($taxonomyMenuBreadcrumb) : 0;

    const LABEL_POSTAL = 'ZIP Code';
    const LABEL_FREE_TEXT = 'Enter search text here';

    onMount(() => {
    })

    const onPostalFieldClick = (e) => {
        clearAlert();
    }

    const onPostalFieldKeyup = (e) => {
        if (e.key == 'Enter' && $masterSearch.location.postalCode.length === 5) {
            _onPostalMagnifyClick();
        }
    }

    const onTextFieldClick = (e) => {
        clearAlert();
    }

    const onTextFieldKeyup = (e) => {
        if (e.key == 'Enter') {
            _onFilterMagnifyClick();
        }
    }


    // this calls the main ZIP Code search - no filters
    const _onPostalMagnifyClick = async () => {
        const isValidZipCode = await asyncValidatePostalCode($masterSearch.location.postalCode)
        if (!isValidZipCode) {
            $isShowingZipError = true
            return false
        } else {
            $isShowingZipError = false
            onPostalSearch();
        }
    }

    // this calls the Filter search - includes filter params
    const _onFilterMagnifyClick = async () => {
        const isValidZipCode = await asyncValidatePostalCode($masterSearch.location.postalCode)
        if (!isValidZipCode) {
            $isShowingZipError = true
            return false
        } else {
            $isShowingZipError = false
            onFilterSearch();
        }
    }

</script>


<style>
    .public-search-bar {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }

    .rounded {
        max-width: 145px;
        padding: 5px 5px 5px 25px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        /* border: 1px solid var(--tcare-field-bg-readonly); */
        border-radius: 30px;
        background-color: var(--tcui-primary);
    }

    .rounded-2 {
        padding: 5px 5px 5px 25px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        border: 1px solid var(--tcare-field-bg-readonly);
        border-radius: 30px;
    }

    .search-text-input {
        outline: none;
        margin-right: 10px;
        font-size: 18px;
        padding: 5px;
        border: none;
        /* border-bottom: 1px solid var(--tcare-field-bg-readonly); */
    }    

    .search-text-input.postal {
        width: 90px;
        color: var(--tcui-white);
        background-color: var(--tcui-primary);
    }    

    .search-text-input.free-text {
        width: 160px;
        color: var(--tcui-primary);
    }    


    .search-icon {
        width: 34px;
        height: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
        user-select: none;
        background-color: #A075A5;
        border-radius: 50%;
    }

    :global(.search-icon svg) {
        width: 65%;
        height: 65%;
        fill: var(--tcui-primary);
        outline: none;
    }

    .search-icon-2 {
        width: 34px;
        height: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
        user-select: none;
        /* background-color: #A075A5; */
        border: 1px solid var(--tcare-field-bg-readonly);
        border-radius: 50%;
    }

    :global(.search-icon-2 svg) {
        width: 65%;
        height: 65%;
        fill: var(--tcui-primary);
        outline: none;
    }


    .search-icon:hover {
        /* background-color: var(--tcare-secondary); */
    }

    .is-searching {
        font-size: 16px;
        /* font-weight: 800; */
        padding: 6px 20px;
        color: var(--tcare-purple);
    }

    /* if not showing magnifying glass */
    .spacer-20 {
        width: 20px;
    }

    .error-icon {
        color: #FE4672;
        width: 24px;
        height: 24px;
    }
    
    /* non-standard way to change the placeholder color */
    ::placeholder {
        font-size: 13px;
        color: var(--tcui-dark-gray);
        opacity: 1;                             /* Firefox */
    }

    :-ms-input-placeholder {                    /* Internet Explorer 10-11 */
        font-size: 13px;
        color: var(--tcui-dark-gray);
    }

    ::-ms-input-placeholder {                   /* Microsoft Edge */
        font-size: 13px;
        color: var(--tcui-dark-gray);
    }    



    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }
</style>


<div class="public-search-bar">

    <div style="margin-right: 1em">
        <div class="rounded">

            <input class="search-text-input postal" style="height:24px;"
                   onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                   maxlength="5"
                placeholder={LABEL_POSTAL}
                bind:value={$store.location.postalCode}
                on:click={onPostalFieldClick}
                on:keyup={onPostalFieldKeyup}
            />
            {#if $masterSearch.location.postalCode.length === 5}
                <div class="search-icon" on:click={_onPostalMagnifyClick}>
                    <Icon component={Svg} viewBox="0 0 24 24">
                        <path d={mdiMagnify}/>
                    </Icon>
                </div>
            {/if}

        </div>
        <div class="spacer-20"></div>
<!--        error message below         -->
        {#if $isShowingZipError}
            <div style="display:flex; flex-direction:row; align-items:center">
                <div class="error-icon" style="margin-top:.5em">
                    <MdErrorOutline />
                </div>
                <div style="margin-top:.5em; color: #FE4672; padding-left: .25em">Please enter a valid ZIP Code.</div>
            </div>
        {/if}
    </div>

        {#if $store.postalResults.length > 0 && isShowingFreeText}
        <div class="rounded-2">
            <input class="search-text-input free-text"
                placeholder={LABEL_FREE_TEXT}
                bind:value={$store.text}
                on:click={onTextFieldClick}
                on:keyup={onTextFieldKeyup}
            />
            <div class="search-icon-2" on:click={_onFilterMagnifyClick}>
                <Icon component={Svg} viewBox="0 0 24 24">
                    <path d={mdiMagnify}/>
                </Icon>
            </div>
        </div>
        {/if}

    <!-- {/if} -->
</div>
